import React from 'react'
import PropTypes from 'prop-types'
import { ResponsiveBreakpointsProvider } from 'contexts/ResponsiveBreakpointsContext'
import useResponsiveBreakpointsRollout, {
  RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS
} from 'utils/hooks/useResponsiveBreakpointsRollout'

const ResponsiveBreakpointsRolloutBoundary = ({
  children,
  fallback = null,
  page
}) => {
  const version = useResponsiveBreakpointsRollout(page)

  if (version === RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.PENDING) {
    return fallback
  }

  return (
    <ResponsiveBreakpointsProvider value={version}>
      {children}
    </ResponsiveBreakpointsProvider>
  )
}

ResponsiveBreakpointsRolloutBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
  page: PropTypes.string.isRequired
}

export default ResponsiveBreakpointsRolloutBoundary
